import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'inner-shadow-bottom-right',
  'IconInnerShadowBottomRight',
  [
    ['path', { d: 'M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z', key: 'svg-0' }],
    ['path', { d: 'M18 12a6 6 0 0 1 -6 6', key: 'svg-1' }],
  ],
);
